"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConstant = useConstant;

var _react = require("react");

function useConstant(factory) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var mountRef = (0, _react.useRef)(false);
  var valueRef = (0, _react.useRef)();

  if (!valueRef.current) {
    valueRef.current = factory();
  }

  (0, _react.useEffect)(function () {
    if (!mountRef.current) {
      mountRef.current = true;
    } else {
      valueRef.current = factory();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, deps);
  return valueRef.current;
}